<div class="container">
  <div class="row">
    <div class="col">
      <p class="mt-4 text-center text-information">
        {{ 'dictionary.info' | transloco }}
      </p>
      <form>
        <div class="input-group">
          <input
            type="text"
            [placeholder]="'dictionary.enter_word' | transloco"
            class="form-control"
            #dictionary />
          <span class="ml-3 input-group-btn d-block">
            <button
              class="btn btn-default btn-yellow"
              type="button"
              (click)="add(dictionary.value)">
              {{ 'dictionary.add' | transloco }}
            </button>
          </span>
        </div>
      </form>
      <div class="dictionary mt-4">
        <ul>
          @for (dict of sortedArray(dictionArray); track dict) {
            <li>
              {{ capitalize(dict.word) }}
              <i
                class="fa fa-trash float-right"
                (click)="remove(dict.word)"></i>
            </li>
          }
        </ul>
        <a href="" routerLink="/speech">{{ 'dictionary.back' | transloco }}</a>
      </div>
    </div>
  </div>
</div>
